import Stack from '@mui/material/Stack';
import Styles from './Styles/Order.module.css'
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import Badge from '@mui/material/Badge';
import { useMemo, useState } from "react"
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import List from '@mui/material/List';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DialogContent from '@mui/material/DialogContent';
import { setIfValidPrice } from '../../../../utils/strings';
import { DELIVERY_METHODS, OPTIONS_VARIANTS, PAYMENT_METHODS } from '../../../../utils/structures';
import { removeBlankAtEnd } from '../../../../utils/strings';


export default function Order(props) {
    const [orderOpen, setOrderOpen] = useState(false);
    const [showOrderDetails, setShowOrderDetails] = useState(false)

    const [paymentMethod, setPaymentMethod] = useState('')
    const [deliveryMethod, setDeliveryMethod] = useState('')
    const [address, setAddress] = useState('')
    const [name, setName] = useState('')
    const [cashAmount, setCashAmount] = useState(0)

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const deliveryCost = props.menu.deliveryCost.free > 0 && props.order.total > props.menu.deliveryCost.free ? '+ envío (Bonificado)' :
        props.menu.deliveryCost.from < 0 ? '+ envío (Consultar)' :
            props.menu.deliveryCost.free === 0 ? '+ envío (Gratis)' :
                props.menu.deliveryCost.from === props.menu.deliveryCost.to ? `+ $${props.menu.deliveryCost.from} envío` : '+ envío'

    const sendOrderViaWhatsApp = (order) => {
        // Format the order into text
        let formattedOrder = '_Detalle de orden:_\n\n';
        for (const product of order.products) {
            formattedOrder += `*${product.name}: $${product.price}*\n`;

            // Include options if they exist
            if (product.options.length > 0) {
                for (const option of product.options) {
                    formattedOrder += `  ${option.name}:\n`;

                    if (option.type === OPTIONS_VARIANTS.selectOption) {
                        for (const subOption of option.subOptions) {
                            formattedOrder += `    ${subOption.name} ${subOption.price === 0 ? "" : "(+$" + subOption.price + ")"}\n`
                        }

                    } else {
                        for (const subOption of option.subOptions) {
                            if (subOption.units > 0) {
                                formattedOrder += `    ${subOption.name} (x${subOption.units}) ${subOption.price === 0 ? "" : "(+$" + subOption.price * subOption.units + ")"}\n`
                            }
                        }
                    }
                }
            }

            const note = product.note === '' ? '' : removeBlankAtEnd(product.note)
            formattedOrder += product.note !== '' ? '_*Nota:* ' + note + '_\n' : '';
            formattedOrder += `$${product.count * (product.price + product.extraPrice)} ${product.count > 0 ? '(x' + product.count + ')' : ''}\n`;
            formattedOrder += '----------\n';
        }

        formattedOrder += '_Datos:_\n'
        if (paymentMethod) {
            formattedOrder += paymentMethod === PAYMENT_METHODS.cash ? '*Efectivo*\n' :
                paymentMethod === PAYMENT_METHODS.mercadopago ? '*MercadoPago*\n' :
                    paymentMethod === PAYMENT_METHODS.transfer ? '*Transferencia*\n' : ''
        }
        if (deliveryMethod) {
            formattedOrder += deliveryMethod === DELIVERY_METHODS.delivery ? '*Delivery*\n' :
                deliveryMethod === DELIVERY_METHODS.takeaway ? '*Retirar por el negocio*\n' : ''
        }
        formattedOrder += name ? `Nombre: ${name}\n` : ''
        formattedOrder += address ? `Dirección: ${address}\n` : ''
        formattedOrder += cashAmount ? `Paga con: $${cashAmount}\n` : ''

        formattedOrder += '--------------------\n'
        formattedOrder += `*Total: $${(order.total).toFixed(2)}* ${deliveryCost}`;

        // Encode the text message and phone number for use in a WhatsApp link
        const encodedMessage = encodeURIComponent(formattedOrder);

        // Create the WhatsApp link
        const link = `https://wa.me/${props.menu.phoneNumber}?text=${encodedMessage}`;

        // Open the WhatsApp app with the message ready to be sent
        window.open(link);
    }

    const getSuboptionsResume = option => {
        let result = []
        if (option.type === OPTIONS_VARIANTS.addUnits) {
            for (let i = 0; i < option.subOptions.length; i++) {

                if (option.subOptions[i].units > 0) {
                    result.push(`${option.subOptions[i].name} x${option.subOptions[i].units}`)
                }
            }

        } else {
            for (let i = 0; i < option.subOptions.length; i++) {
                result.push(option.subOptions[i].name)
            }
        }
        return result
    }

    const productsResume = useMemo(() => {
        return <List>
            {props.order.products.map((product, prodIndex) => {
                return (<div key={prodIndex}>
                    <div className={Styles.orderProduct}>

                        <div className={Styles.image} style={{ backgroundImage: 'url(' + product.image + ')' }}></div>

                        <div className={Styles.orderProductInfo}>
                            <Typography fontWeight={600}>{product.name}</Typography>

                            <Typography variant='body2'>
                                {product.options.map(option => {

                                    if (!option.subOptions) {
                                        return null
                                    }

                                    return getSuboptionsResume(option).join(', ')
                                }).join(', ')}
                            </Typography>

                            {!product.note ? null :
                                <Typography variant='body2'>
                                    Aclaración: {product.note}
                                </Typography>
                            }
                            <Typography fontWeight={600}>
                                ${((product.price + product.extraPrice) * product.count).toFixed(2)}
                            </Typography>
                        </div>

                        <div className={Styles.orderProductActions} style={{ width: '100%' }}>
                            {product.count <= 1 ?
                                <IconButton onClick={() => props.removeProductFromOrder(prodIndex)} color='error'>
                                    <DeleteOutlineIcon />
                                </IconButton> :
                                <IconButton onClick={() => props.changeProductAmount(prodIndex, -1)}>
                                    <RemoveIcon />
                                </IconButton>}

                            <Typography fontWeight={600}>{product.count}x</Typography>

                            <IconButton onClick={() => props.changeProductAmount(prodIndex, 1)}>
                                <AddIcon />
                            </IconButton>
                        </div>

                    </div>

                    <Divider />
                </div>)
            })}
        </List>
    }, [props.order.products, props.removeProductFromOrder, props.changeProductAmount, props.changeProductAmount])


    const deliveryOptionsRadio = useMemo(() => {
        if (props.menu.deliveryOptions) {
            return props.menu.deliveryOptions.map((option, index) => {
                const label = option === DELIVERY_METHODS.delivery ? 'Delivery' :
                    option === DELIVERY_METHODS.inPlace ? 'Comer en el lugar' :
                        option === DELIVERY_METHODS.takeaway ? 'Retirar por el negocio' : ''

                return <FormControlLabel value={option} control={<Radio />} label={label} key={index} />
            })
        }
        return null

    }, [props.menu.deliveryOptions])


    const paymentOptionsRadio = useMemo(() => {
        if (props.menu.paymentOptions) {
            return props.menu.paymentOptions.map((option, index) => {
                const label = option === PAYMENT_METHODS.cash ? 'Efectivo' :
                    option === PAYMENT_METHODS.mercadopago ? 'MercadoPago' :
                        option === PAYMENT_METHODS.transfer ? 'Transferencia' : ''

                return <FormControlLabel value={option} control={<Radio />} label={label} key={index} />
            })
        }

        return null
    }, [props.menu.paymentOptions])

    return (
        <>
            <div className={`${Styles.orderSnackBar} ${props.displayRelative ? Styles.snackBarRelative : Styles.snackBarFixed}`} onClick={() => setOrderOpen(true)}>
                <Badge color="primary" badgeContent={props.order.products.length} max={99}>
                    <LocalGroceryStoreOutlinedIcon />
                </Badge>
                <Typography fontWeight={500}>Ver mi pedido</Typography>
                <Typography fontWeight={500}>${(props.order.total).toFixed(2)}</Typography>
            </div>

            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth="md"
                open={orderOpen}
                onClose={() => { setOrderOpen(false); setShowOrderDetails(false) }}
                aria-labelledby="responsive-dialog-title"
            >

                {showOrderDetails ?
                    <>
                        <Stack direction='row' alignItems='center' justifyContent='center' sx={{ margin: '15px 10px 0px 10px' }}>
                            <IconButton autoFocus onClick={() => setShowOrderDetails(false)}>
                                <ArrowBackIcon fontSize="large" />
                            </IconButton>

                            <Typography sx={{ width: '100%' }} variant='h5' >Detalle de tu orden</Typography>
                            <IconButton
                                autoFocus
                                onClick={() => { setShowOrderDetails(false); setOrderOpen(false) }}
                            >
                                <CloseIcon fontSize="large" />
                            </IconButton>
                        </Stack>
                        <DialogContent>
                            <Typography variant='h5' fontWeight={500}>{props.menu.title}</Typography>
                            <Typography variant='h6'>{`$${(props.order.total).toFixed(2)} ${deliveryMethod === DELIVERY_METHODS.delivery ? deliveryCost : ''}`}</Typography>

                            <Stack spacing={1}>

                                <Divider />

                                {props.menu.deliveryOptions ?
                                    <FormControl fullWidth>
                                        <FormLabel id="demo-radio-buttons-group-label">Forma de entrega</FormLabel>

                                        <RadioGroup
                                            defaultValue="1"
                                            value={deliveryMethod}
                                            onChange={(e) => setDeliveryMethod(e.target.value)}
                                        >
                                            {deliveryOptionsRadio}
                                        </RadioGroup>
                                    </FormControl> : null}

                                {deliveryMethod === DELIVERY_METHODS.inPlace || !props.menu.paymentOptions ? null :
                                    <>
                                        <Divider />

                                        <FormControl fullWidth>
                                            <FormLabel id="demo-radio-buttons-group-label">Metodo de pago</FormLabel>

                                            <RadioGroup
                                                defaultValue="1"
                                                value={paymentMethod}
                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                            >
                                                {paymentOptionsRadio}
                                            </RadioGroup>
                                        </FormControl>
                                    </>}

                                <Divider />

                                {deliveryMethod === DELIVERY_METHODS.delivery ?
                                    <>
                                        <Typography variant='h6'>Dirección para la entrega</Typography>
                                        <TextField
                                            value={address}
                                            onChange={e => { if (e.target.value.length <= 150) { setAddress(e.target.value) } }}
                                            label='Dirección'
                                        />
                                    </> : null}

                                {deliveryMethod === DELIVERY_METHODS.delivery || deliveryMethod === DELIVERY_METHODS.takeaway ?
                                    <>
                                        <Typography variant='h6'>Tu nombre</Typography>
                                        <TextField
                                            value={name}
                                            onChange={e => { if (e.target.value.length <= 50) { setName(e.target.value) } }}
                                            label='Nombre'
                                        />
                                    </> : null}

                                {paymentMethod !== PAYMENT_METHODS.cash || deliveryMethod === DELIVERY_METHODS.inPlace ? null :
                                    <>
                                        <Typography variant='h6'>Con cuanto abona</Typography>
                                        <FormControl fullWidth>
                                            <InputLabel>Monto</InputLabel>
                                            <OutlinedInput
                                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                                value={cashAmount}
                                                onChange={e => setIfValidPrice(e.target.value, setCashAmount)}
                                                label='Monto'
                                            />
                                        </FormControl>
                                    </>}

                                {deliveryMethod === DELIVERY_METHODS.inPlace || props.menu.phoneNumber === '' ?
                                    <>
                                        <Typography variant='h6' textAlign='center'>Para comer en el lugar tienes que llamar al mozo y mostrarle el detalle del pedido que armaste</Typography>
                                        <Button variant='contained' onClick={() => setShowOrderDetails(false)}>
                                            Mostrar detalle del pedido
                                        </Button>
                                    </> : <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => sendOrderViaWhatsApp(props.order)}
                                    >
                                        Hacer pedido por whatsapp
                                    </Button>
                                }

                            </Stack>
                        </DialogContent>
                    </>
                    :
                    <>
                        <Stack direction='row' alignItems='center' justifyContent='center' sx={{ margin: '15px 15px 0px 15px' }}>
                            <Typography sx={{ width: '100%' }} variant='h5' >Detalle de tu orden</Typography>
                            <IconButton
                                autoFocus
                                onClick={() => { setShowOrderDetails(false); setOrderOpen(false) }}
                            >
                                <CloseIcon fontSize="large" />
                            </IconButton>
                        </Stack>
                        <DialogContent>

                            <Typography variant='h5' fontWeight={500}>{props.menu.title}</Typography>

                            <div className={Styles.startBuy}
                                onClick={() => {
                                    if (!props.menu.paymentOptions && !props.menu.deliveryOptions) {
                                        sendOrderViaWhatsApp(props.order)
                                    } else {
                                        setShowOrderDetails(true)
                                    }
                                }}>

                                <Typography fontWeight={500}>Iniciar compra</Typography>
                                <Typography fontWeight={600} fontSize='1.1em'>${(props.order.total).toFixed(2)}</Typography>
                            </div>


                            {productsResume}

                        </DialogContent>
                    </>}
            </Dialog>
        </>
    )
}